import {
  Document,
  Font,
  Page,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import moment from "moment";
import React, { useEffect } from "react";
import iBMPlexRegularFont from "../../../fonts/IBMPlexSansArabic-Regular.ttf";

const PreauthorizationPrintUCAF = ({ printData, row }) => {
  const selectedBranch = JSON.parse(localStorage.getItem("selectedBranch"));

  const selectedType = printData?.provider_request?.visitreasons;

  const visitTypes = [
    { label: "New visit", code: "new-visit" },
    { label: "Follow Up", code: "follow-up" },
    { label: "Refill", code: "refill" },
    { label: "Walk In", code: "walkin" },
    { label: "Referral", code: "referral" },
  ];

  const patientInformation = printData?.provider_request?.patient;
  const preauthResponse = printData?.payer_response;

  // console.log({ preauthResponse });

  const days = preauthResponse?.preauthto
    ? moment(preauthResponse.preauthto, "YYYY-MM-DD").diff(
      moment(preauthResponse.preauthfrom, "YYYY-MM-DD"),
      "days"
    ) + 1
    : 0;

  const messageContent = [
    preauthResponse?.disposition,
    preauthResponse?.remarks,
  ]
    .filter((line) => line)
    .join("\n");

  const practitioners = printData?.provider_request?.practitioner;

  const preauthOrizationMedicalInfo =
    printData?.provider_request?.medical_details;
  const preauthOrizationDiagnosis = printData?.provider_request?.diagnosis;
  const preauthOrizationVitals = printData?.provider_request?.vitals;

  const preauthServicesRequest =
    printData?.provider_request?.service_procedures;
  const preauthServiceResponse = printData?.service_procedures;

  return (
    <Document>
      <Page size="A3" style={styles.page}>
        <Text style={styles.heading}>ucaf 2.0</Text>
        <View style={styles.flexRow}>
          <View style={styles.cardStyle}>
            <Text style={styles.title}>
              To be completed & ID verified by the reception/nurse:
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Provider Name: </Text>
              <Text style={styles.s1textvalue}>
                {selectedBranch?.branch_name || "-"}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Insurance Company Name: </Text>
              <Text style={styles.s1textvalue}>
                {printData?.insurance || ""}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>TPA Company Name: </Text>
              <Text style={styles.s1textvalue}>{row?.payer_name}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Patient File Number: </Text>
              <Text style={styles.s1textvalue}>
                {patientInformation?.mrn || ""}
              </Text>
            </Text>
            <View style={styles.flexRow}>
              <Text style={styles.checkItem}>
                Single {"(  "}
                {")"}
              </Text>
              <Text style={styles.checkItem}>
                Married {"(  "}
                {")"}
              </Text>
              <Text style={styles.checkItem}>
                Plan Type {"(  "}
                {")"}
              </Text>
            </View>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Date of visit: </Text>
              <Text style={styles.s1textvalue}>
                {printData?.provider_request?.req_time
                  ? moment(printData?.provider_request?.req_time).format(
                    "DD-MM-YYYY hh:mm:ss A"
                  )
                  : ""}
              </Text>
            </Text>
            {/* Visit Types Section */}
            <View style={styles.flexRow}>
              {visitTypes.map((item, index) => {
                // Normalize comparison
                const normalize = (str) => str?.toLowerCase().replace(/-/g, "");
                const isSelected =
                  normalize(selectedType) === normalize(item.code);

                return (
                  <Text key={index} style={styles.checkItem}>
                    {item.label} {"("} {`${isSelected ? `✓` : ""}`}
                    {")"}
                  </Text>
                );
              })}
            </View>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Approval Date/Time : </Text>
              <Text style={styles.s1textvalue}>
                {preauthResponse?.response_datetime
                  ? moment(preauthResponse?.response_datetime).format(
                    "DD-MM-YYYY hh:mm:ss A"
                  )
                  : ""}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Approval Validity : </Text>
              <Text style={styles.s1textvalue}>{days} days</Text>
            </Text>
          </View>
          <View style={styles.cardStyle}>
            <Text style={styles.title}>
              Print/Fill in clear letters or Emboss Card:
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Insurance Name: </Text>
              <Text style={styles.s1textvalue}>
                {printData?.insurance || ""}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>National ID / Iqama : </Text>
              <Text style={styles.s1textvalue}>
                {patientInformation?.nationalid || ""}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>ID. Card No. : </Text>
              <Text style={styles.s1textvalue}>
                {patientInformation?.memberid}
              </Text>
            </Text>
            <View style={[styles.flexRow]}>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Sex : </Text>
                <Text
                  style={[styles.s1textvalue, { textTransform: "capitalize" }]}
                >
                  {patientInformation?.gender || ""}
                </Text>
              </Text>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>DOB : </Text>
                <Text style={styles.s1textvalue}>
                  {patientInformation?.birthdate
                    ? moment(patientInformation?.birthdate).format("DD-MM-YYYY")
                    : ""}
                </Text>
              </Text>
            </View>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Policy Holder : </Text>
              <Text style={styles.s1textvalue}>
                {patientInformation?.polycyname || ""}
              </Text>
            </Text>

            <View style={[styles.flexRow]}>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Policy No. : </Text>
                <Text style={styles.s1textvalue}>
                  {patientInformation?.polycyno || ""}
                </Text>
              </Text>
              <View style={[styles.flexRow]}>
                <Text style={styles.dottedLine}>
                  <Text style={styles.s1textLabel}>Expiry Date : </Text>
                  <Text style={styles.s1textvalue}>-</Text>
                </Text>
                <Text style={styles.dottedLine}>
                  <Text style={styles.s1textLabel}>Class : </Text>
                  <Text style={styles.s1textvalue}>
                    {patientInformation?.class || ""}
                  </Text>
                </Text>
              </View>
            </View>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>
                {preauthResponse?.preauth_status}
                Reference Number :{" "}
              </Text>
              <Text style={styles.s1textvalue}>
                {preauthResponse?.preauth_ref || ""}
              </Text>
            </Text>
            <View style={[styles.flexRow]}>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Approval Status : </Text>
                <Text style={styles.s1textvalue}>
                  {preauthResponse?.preauth_status || ""}
                </Text>
              </Text>
            </View>
            <View style={[styles.flexRow]}>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Approval Type : </Text>
                <Text style={styles.s1textvalue}>
                  {preauthResponse?.claim_typenme?.toLowerCase() === "oral"
                    ? "Dental"
                    : preauthResponse?.claim_typenme || ""}
                </Text>
              </Text>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Approval Sub Type : </Text>
                <Text style={styles.s1textvalue}>
                  {preauthResponse?.preauth_subtype || ""}
                </Text>
              </Text>
            </View>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Message : </Text>
              <Text style={styles.s1textvalue}>{messageContent}</Text>
            </Text>
          </View>
        </View>

        <View style={styles.card}>
          <Text style={styles.title}>
            To be Completed by the Attending PHYSICIAN: Please tick(✓)
          </Text>
          <View style={styles.flexRow}>
            <Text style={styles.checkItem}>
              Inpatient{" "}
              {preauthResponse?.preauth_subtype?.toLowerCase() === "inpatient"
                ? "(✓)"
                : "( )"}
            </Text>
            <Text style={styles.checkItem}>
              Outpatient{" "}
              {preauthResponse?.preauth_subtype?.toLowerCase() === "outpatient"
                ? "(✓)"
                : "( )"}
            </Text>

            <View style={styles.emergencyCasStyle}>
              <Text style={styles.checkItem}>
                <Text style={styles.dottedLine}>
                  <Text style={styles.s1textLabel}>
                    Emergencey Case{" "}
                    {preauthResponse?.preauth_subtype?.toLowerCase() ===
                      "emergency"
                      ? "(✓)"
                      : "( )"}
                  </Text>
                  <Text style={styles.s1textvalue}>| Emergency Level:</Text>
                </Text>
              </Text>
              <Text style={styles.checkItem}> 1 ( ) </Text>
              <Text style={styles.checkItem}> 2 ( ) </Text>
              <Text style={styles.checkItem}> 3 ( )</Text>
            </View>
          </View>
          <View style={[styles.flexRow]}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Physician Name [ID]: </Text>
              <Text style={styles.s1textvalue}>
                {practitioners?.[0]?.practitioner_name || ""}
              </Text>
            </Text>
          </View>
          <View style={[styles.flexRow]}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>BP: </Text>
              <Text style={styles.s1textvalue}>
                {preauthOrizationVitals?.systolic || ""}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Pulse: </Text>
              <Text style={styles.s1textvalue}>
                {preauthOrizationVitals?.pulse || ""}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Temp: </Text>
              <Text style={styles.s1textvalue}>
                {preauthOrizationVitals?.temperature || ""}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Weight: </Text>
              <Text style={styles.s1textvalue}>
                {preauthOrizationVitals?.weight || ""}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Height: </Text>
              <Text style={styles.s1textvalue}>
                {preauthOrizationVitals?.height || ""}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>R.R: </Text>
              <Text style={styles.s1textvalue}>
                {" "}
                {preauthOrizationVitals?.respiratoryrate || ""}
              </Text>
            </Text>
          </View>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>Duration of illness: </Text>
            <Text style={styles.s1textvalue}>
              {" "}
              {preauthOrizationMedicalInfo?.presentillness || ""}
            </Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>
              Chief Complaints and Main Symptoms:{" "}
            </Text>
            <Text style={styles.s1textvalue}>
              {preauthOrizationMedicalInfo?.chiefcomplaint || ""}
            </Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>Treatment Plan: </Text>
            <Text style={styles.s1textvalue}>
              {preauthOrizationMedicalInfo?.treatmentplan || ""}
            </Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>Patient History: </Text>
            <Text style={styles.s1textvalue}>
              {preauthOrizationMedicalInfo?.patienthistory || ""}
            </Text>
          </Text>
          <View style={[styles.flexRow]}>
            {preauthOrizationDiagnosis?.map((item, index) => {
              const label =
                index === 0
                  ? "Principal Code"
                  : `${index + 1}${["st", "nd", "rd", "th"][index] || "th"
                  } Code`;

              return (
                <Text key={index} style={styles.dottedLine}>
                  <Text style={styles.s1textLabel}>{label}: </Text>
                  <Text style={styles.s1textvalue}>
                    {item?.diagonis_code
                      ? `(${item?.diagonis_code}) - ${item?.diagonis_description}`
                      : item?.diagonis_description || "".padEnd(40, " ")}
                  </Text>
                </Text>
              );
            })}
          </View>

          <View style={styles.commentLine} />
          <Text style={styles.title}>Please tick(✓) where appropriate :</Text>
          <View style={styles.flexRow}>
            <Text style={styles.checkItem}>Chronic ( )</Text>
            <Text style={styles.checkItem}>Congenital ( )</Text>
            <Text style={styles.checkItem}>RTA ( )</Text>
            <Text style={styles.checkItem}>Work Related ( )</Text>
            <Text style={styles.checkItem}>Vaccination ( )</Text>
            <Text style={styles.checkItem}>Check-up ( )</Text>
          </View>
          <View style={styles.flexRow}>
            <Text style={styles.checkItem}>Psychiatric ( )</Text>
            <Text style={styles.checkItem}>Infertility ( )</Text>
            <Text style={styles.checkItem}>Pregnancy ( )</Text>
            <Text style={styles.checkItem}>Indicate LMP: ..........</Text>
          </View>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textvalue}>
              {" "}
              Suggestive line(s) of management: Kindly, enumerate the
              recommended investigaions, and/or procedures
            </Text>
            <Text style={styles.s1textLabel}>
              {" "}
              For outpatient approvals only:{" "}
            </Text>
          </Text>
          <View style={[styles.card]}>
            <View style={styles.table}>
              {/* Table Header */}
              <View style={styles.tableRow}>
                <Text style={[styles.tableCellSer, styles.descriptionCellSer]}>
                  (Code) Service
                </Text>
                <Text style={styles.tableCellSer}>Type</Text>
                <Text style={styles.tableCellSer}>Req Qty</Text>
                <Text style={styles.tableCellSer}>Unit Price</Text>
                <Text style={styles.tableCellSer}>Gross</Text>
                <Text style={styles.tableCellSer}>App Qty</Text>
                <Text style={styles.tableCellSer}>App Cost</Text>
                <Text style={[styles.tableCellSer, styles.lastTableCellSer]}>
                  Note
                </Text>
              </View>

              {preauthServicesRequest?.filter(
                (item) => item?.prdtypcde == "itm_prdt"
              )?.length > 0 ? (
                preauthServicesRequest
                  ?.filter((item) => item?.prdtypcde == "itm_prdt")
                  ?.map((item, index, array) => {
                    const isLast = index === array.length - 1;

                    // Calculations
                    const quantity = parseFloat(item?.servinfo_prdqty) || 0;
                    const unitPrice = parseFloat(item?.servinfo_prdpri) || 0;
                    const gross = (quantity * unitPrice).toFixed(2);

                    const approvedService = preauthServiceResponse?.[index];
                    const approvedQty = parseFloat(item?.apprv_qty) || 0;
                    const grossApproved = (approvedQty * unitPrice).toFixed(2);

                    return (
                      <View style={[styles.tableRow, ,]} key={index}>
                        <Text
                          style={[
                            styles.tableCellSer,
                            styles.descriptionCellSer,
                            isLast && { borderBottom: "1px solid #999" },
                          ]}
                        >
                          {item?.itemcode && `(${item.itemcode}) `}
                          {item?.itemdescp}
                          {item?.itemlclcode && ` (${item?.itemlclcode})`}
                          {item?.itemlcldescp}
                        </Text>

                        <Text
                          style={[
                            styles.tableCellSer,
                            isLast && { borderBottom: "1px solid #999" },
                          ]}
                        >
                          Procedures
                        </Text>
                        <Text
                          style={[
                            styles.tableCellSer,
                            isLast && { borderBottom: "1px solid #999" },
                          ]}
                        >
                          {quantity}
                        </Text>
                        <Text
                          style={[
                            styles.tableCellSer,
                            isLast && { borderBottom: "1px solid #999" },
                          ]}
                        >
                          {unitPrice.toFixed(2)}
                        </Text>
                        <Text
                          style={[
                            styles.tableCellSer,
                            isLast && { borderBottom: "1px solid #999" },
                          ]}
                        >
                          {gross}
                        </Text>
                        <Text
                          style={[
                            styles.tableCellSer,
                            isLast && { borderBottom: "1px solid #999" },
                          ]}
                        >
                          {approvedService?.apprv_qty || "0"}
                        </Text>
                        <Text
                          style={[
                            styles.tableCellSer,
                            isLast && { borderBottom: "1px solid #999" },
                          ]}
                        >
                          {grossApproved || "0.00"}
                        </Text>
                        <Text
                          style={[
                            styles.tableCellSer,
                            isLast && { borderBottom: "1px solid #999" },
                            styles.lastTableCellSer,
                          ]}
                        >
                          {approvedService?.serv_status || ""}
                        </Text>
                      </View>
                    );
                  })
              ) : (
                <View style={styles.tableRow}>
                  <Text style={[styles.tableCellSer, styles.noDataCell]}>
                    No Data To Show
                  </Text>
                </View>
              )}
            </View>
            <View style={[styles.flexRow]}>
              <Text style={[styles.s1textLabel, styles.text, styles.mt3]}>
                Providers Approval/Coding Staff must review/code the recommended
                service(s) and allocate cost and complete the following:
              </Text>
            </View>
            <View style={[styles.flexRow]}>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Completed / Coded By: </Text>
                <Text style={styles.s1textvalue}> {"."?.repeat(30)}</Text>
              </Text>

              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Signature: </Text>
                <Text style={styles.s1textvalue}> {"."?.repeat(30)}</Text>
              </Text>

              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Date: </Text>
                <Text style={styles.s1textvalue}>
                  {" "}
                  {"."?.repeat(15)}/{"."?.repeat(15)}/{"."?.repeat(15)}
                </Text>
              </Text>
            </View>
            <View style={styles.section}>
              <View style={styles.table}>
                {/* Table Header */}
                <View style={styles.tableRow}>
                  <Text
                    style={[styles.tableCellSer, styles.descriptionCellSer]}
                  >
                    Medication Name (Generic Name)
                  </Text>
                  <Text style={styles.tableCellSer}>Type</Text>
                  <Text style={styles.tableCellSer}>Req Qty</Text>
                  <Text style={styles.tableCellSer}>Unit Price</Text>
                  <Text style={styles.tableCellSer}>Gross</Text>
                  <Text style={styles.tableCellSer}>App Qty</Text>
                  <Text style={styles.tableCellSer}>App Cost</Text>
                  <Text style={[styles.tableCellSer, styles.lastTableCellSer]}>
                    Note
                  </Text>
                </View>

                {/* Table Rows */}
                {preauthServicesRequest?.filter(
                  (item) => item?.prdtypcde != "itm_prdt"
                )?.length > 0 ? (
                  preauthServicesRequest
                    ?.filter((item) => item?.prdtypcde != "itm_prdt")
                    ?.map((item, index, array) => {
                      const isLast = index === array.length - 1;

                      // Calculations
                      const quantity = parseFloat(item?.servinfo_prdqty) || 0;
                      const unitPrice = parseFloat(item?.servinfo_prdpri) || 0;
                      const gross = (quantity * unitPrice).toFixed(2);

                      const approvedService = preauthServiceResponse?.[index];
                      const approvedQty = parseFloat(item?.apprv_qty) || 0;
                      const grossApproved = (approvedQty * unitPrice).toFixed(
                        2
                      );
                      return (
                        <View style={[styles.tableRow, ,]} key={index}>
                          <Text
                            style={[
                              styles.tableCellSer,
                              styles.descriptionCellSer,
                              isLast && { borderBottom: "1px solid #999" },
                            ]}
                          >
                            {item?.itemcode && `(${item.itemcode}) `}
                            {item?.itemdescp}
                            {item?.itemlclcode && ` (${item?.itemlclcode})`}
                            {item?.itemlcldescp}
                          </Text>

                          <Text
                            style={[
                              styles.tableCellSer,
                              isLast && { borderBottom: "1px solid #999" },
                            ]}
                          >
                            Medication
                          </Text>
                          <Text
                            style={[
                              styles.tableCellSer,
                              isLast && { borderBottom: "1px solid #999" },
                            ]}
                          >
                            {quantity}
                          </Text>
                          <Text
                            style={[
                              styles.tableCellSer,
                              isLast && { borderBottom: "1px solid #999" },
                            ]}
                          >
                            {unitPrice.toFixed(2)}
                          </Text>
                          <Text
                            style={[
                              styles.tableCellSer,
                              isLast && { borderBottom: "1px solid #999" },
                            ]}
                          >
                            {gross}
                          </Text>
                          <Text
                            style={[
                              styles.tableCellSer,
                              isLast && { borderBottom: "1px solid #999" },
                            ]}
                          >
                            {approvedService?.apprv_qty || "0"}
                          </Text>
                          <Text
                            style={[
                              styles.tableCellSer,
                              isLast && { borderBottom: "1px solid #999" },
                            ]}
                          >
                            {grossApproved || "0.00"}
                          </Text>
                          <Text
                            style={[
                              styles.tableCellSer,
                              isLast && { borderBottom: "1px solid #999" },
                              styles.lastTableCellSer,
                            ]}
                          >
                            {approvedService?.serv_status || ""}
                          </Text>
                        </View>
                      );
                    })
                ) : (
                  <View style={styles.tableRow}>
                    <Text style={[styles.tableCellSer, styles.noDataCell]}>
                      No Data To Show
                    </Text>
                  </View>
                )}
              </View>
            </View>
          </View>

          <View style={[styles.flexRow]}>
            <Text style={styles.s1textLabel}>
              In case Management Form (CMF1.0) included
              <View style={[styles.flexRow, { marginRight: 5, marginLeft: 5 }]}>
                <Text style={styles.checkItem}> {"  "}Yes ( )</Text>
                <Text style={styles.checkItem}>{"  "}No ( )</Text>
              </View>
            </Text>
          </View>
          <View style={[styles.flexRow]}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>
                Please Specify possible line of management when applicable:{" "}
              </Text>
              <Text style={styles.s1textLabel}>{"."?.repeat(70)}</Text>
            </Text>
          </View>
          <View style={[styles.flexRow]}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Estimated Length of stay: </Text>
              <Text style={styles.s1textLabel}>{"."?.repeat(40)} Days</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>
                Expected data of admission:{" "}
              </Text>
              <Text style={styles.s1textLabel}>{"."?.repeat(40)} Days</Text>
            </Text>
          </View>
        </View>

        <View style={[styles.flexRow]}>
          <View style={styles.cardStyle}>
            <Text style={styles.s1textvalue}>
              I hereby certify that ALL information mentioned are correct and
              that the medical services shown on this form were medically
              indicated and necessary for the management of this case.
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Physician: </Text>
              <Text style={styles.s1textvalue}>{"."?.repeat(70)}</Text>
            </Text>
            <View style={[styles.flexRow]}>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Signature: </Text>
                <Text style={styles.s1textvalue}>{"."?.repeat(40)}</Text>
              </Text>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Date: </Text>
                <Text style={styles.s1textvalue}>
                  {"."?.repeat(15)}/{"."?.repeat(15)}/{"."?.repeat(15)}
                </Text>
              </Text>
            </View>
          </View>
          <View style={styles.cardStyle}>
            <Text style={styles.s1textvalue}>
              I hereby certify that ALL statements and information provided
              concerning patient identification and the present illness or
              injury are TRUE.
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>
                Name (and relationship if guardian):{" "}
              </Text>
              <Text style={styles.s1textvalue}>{"."?.repeat(50)}</Text>
            </Text>
            <View style={[styles.flexRow]}>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Signature(*) </Text>
                <Text style={styles.s1textvalue}></Text>
              </Text>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Date: </Text>
                <Text style={styles.s1textvalue}>
                  {"."?.repeat(15)}/{"."?.repeat(15)}/{"."?.repeat(15)}
                </Text>
              </Text>
            </View>
          </View>
        </View>
        <View style={styles.card}>
          <View style={[styles.flexRow]}>
            <Text style={styles.dottedLine}>
              <Text style={[styles.s1textLabel, { marginRight: "16px" }]}>
                For Insurance Company use Only
              </Text>
              <Text style={styles.s1textvalue}>
                {printData?.preauth_status === "approved" ? (
                  <>{"  "}Approved (✓) Not Approved ( )</>
                ) : (
                  <>Approved ( ) Not Approved (✓)</>
                )}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Approval No: {"  "}</Text>
              <Text style={styles.s1textvalue}>
                {preauthResponse?.preauth_ref || ""}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Approval validity </Text>
              <Text style={styles.s1textvalue}>{days}</Text>
            </Text>
          </View>
          <Text style={styles.s1textvalue}>
            Comments (include approved days/services if different from the
            requested)
          </Text>
          <Text style={[styles.s1textvalue, { paddingTop: 5 }]}>
            {"."?.repeat(100)}
          </Text>
          <View style={styles.flexRow}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>
                Approved/Disapproved By {"  "}
              </Text>
              <Text style={styles.s1textvalue}>{"."?.repeat(20)}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Signature {"  "}</Text>
              <Text style={styles.s1textvalue}>{"."?.repeat(20)}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Date: </Text>
              <Text style={styles.s1textvalue}>
                {"."?.repeat(15)}/{"."?.repeat(15)}/{"."?.repeat(15)}
              </Text>
            </Text>
          </View>
        </View>
        <Text style={styles.s1textLabel}>
          (*) this is applicable only in case of manual UCAF{" "}
        </Text>

        <Text style={styles.createdBy} fixed>
          {`Printed by: |  ${moment().format("lll")}`}
        </Text>
        <Text
          style={styles.pageNumber}
          render={({ pageNumber, totalPages }) =>
            `Page ${pageNumber || ""} of ${totalPages || ""}`
          }
          fixed
        />
      </Page>
    </Document>
  );
};

export default PreauthorizationPrintUCAF;

Font.register({
  family: "IBM Plex Sans Arabic",
  src: iBMPlexRegularFont,
});

const styles = StyleSheet.create({
  heading: {
    fontSize: 24,
    textAlign: "center",
    textTransform: "uppercase",
    color: "#000",
    fontWeight: 700,
    marginBottom: 10,
  },
  flexRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 1,
    marginBottom: 1,
  },
  flexColumn: {
    flexDirection: "column",
  },
  cardStyle: {
    padding: "8px 16px",
    border: "2px solid black",
    borderRadius: 15,
    marginTop: 5,
    width: "50%",
  },
  cardDetails: {
    padding: "8px 16px",
    borderRadius: 15,
    marginTop: 0,
  },
  cardStyle1: {
    padding: "8px 16px",
    borderRadius: 15,
    marginTop: 5,
    width: "60%",
  },
  cardStyle2: {
    padding: "8px 16px",
    borderRadius: 15,
    marginTop: 5,
    width: "40%",
  },
  title: {
    fontWeight: 700,
    fontSize: 10,
    color: "#000",
    marginBottom: 5,
  },
  dottedLine: {
    // borderBottom: "1px dashed #5f5f5f",
    marginBottom: 5,
    fontWeight: "bold",
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: 1,
    color: "#333",
  },
  s1textLabel: {
    fontWeight: "bold",
    // marginRight: 1,
  },
  checkText: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: 12,
  },
  s1textvalue: {
    fontWeight: "normal",
    marginRight: 1,
    color: "#1f1e1e",
  },
  mt2: {
    marginTop: 0,
  },
  mt3: {
    marginTop: 5,
  },
  mt4: {
    marginTop: 10,
  },
  page: {
    paddingTop: 20,
    paddingBottom: 30,
    paddingHorizontal: 10,
    fontSize: 9,
    lineHeight: 1.6,
    backgroundColor: "#fff",
    textTransform: "capitalize",
    fontFamily: "IBM Plex Sans Arabic",
  },

  card: {
    border: "2px solid #000",
    borderRadius: 15,
    padding: 5,
    marginTop: 5,
    marginBottom: 5,
  },
  emergencyCasStyle: {
    flexDirection: "row",
    justifyContent: "space-between",
    border: "1px solid #000",
    borderRadius: 15,
    padding: 1,
    padding: 5,
    width: "70%",
    fontSize: 10,
    paddingRight: 1,
  },
  checkItem: {
    flexDirection: "row",
    alignItems: "center",
    fontSize: 10,
    paddingRight: 5,
  },
  textLabel: {
    fontSize: 10,
    fontWeight: "normal",
    marginRight: 2,
  },
  table: {
    display: "table",
    width: "auto",
    marginTop: 5,
    borderCollapse: "collapse", // Add this for better border handling
  },
  tableCell: {
    borderTop: "0.7px solid #999",
    borderLeft: "0.7px solid #999",
    padding: 0,
    textAlign: "center",
    fontSize: 10,
    width: "15%",
    // Remove right and bottom borders from individual cells
  },
  descriptionCell: {
    width: "40%",
  },
  descriptionCell1: {
    width: "55%",
  },
  // Add a new style for the last cell in row
  lastTableCell: {
    borderRight: "0.7px solid #999",
  },
  lastRowBorder: {
    borderBottomWidth: 1,
    borderColor: "#999", // or any color you use for table lines
  },

  tableCellSer: {
    borderTop: "0.7px solid #999",
    borderLeft: "0.7px solid #999",
    padding: 1,
    textAlign: "center",
    fontSize: 8,
    width: "10%",
  },
  noDataCell: {
    width: "100%",
    textAlign: "center",
    padding: 10,
    borderBottom: "0.7px solid #999",
    borderLeft: "0.7px solid #999",
    borderRight: "0.7px solid #999",
  },
  lastTableCellSer: {
    borderRight: "0.7px solid #999",
    width: "10%",
  },
  descriptionCellSer: {
    width: "30%",
  },
  tableCell1: {
    borderTop: "0.7px solid #999",
    borderLeft: "0.7px solid #999",
    padding: 5,
    textAlign: "center",
    fontSize: 10,
    width: "20%",
    // Remove right and bottom borders from individual cells
  },
  descriptionCell1: {
    width: "60%",
  },
  // Add a new style for the last cell in row
  lastTableCell1: {
    borderRight: "0.7px solid #999",
  },

  tableRow: {
    flexDirection: "row",
  },

  labelRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingBottom: 5,
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginTop: 10,
  },
  text: {
    marginBottom: 10,
    fontSize: 9,
    lineHeight: 1.3,
  },
  signatureSection: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 10,
  },
  line: {
    width: 100,
    borderBottomWidth: 1,
    borderColor: "#000",
  },

  insSec: {
    marginTop: 10,
    padding: 10,
    borderWidth: 1,
    borderColor: "#000",
    borderRadius: 5,
  },
  insRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 5,
  },
  checkboxGroup: {
    flexDirection: "row",
    alignItems: "center",
  },
  checkbox: {
    width: 10,
    height: 10,
    borderWidth: 1,
    borderColor: "#000",
    marginRight: 5,
  },
  commentLine: {
    marginTop: 0,
    borderBottomWidth: 1,
    borderColor: "#b5b5b5",
  },
  footer: {
    left: 0,
    right: 0,
    bottom: 0,
    padding: 24,
    margin: "auto",
    borderTopWidth: 1,
    borderStyle: "solid",
    position: "absolute",
    borderColor: "#DFE3E8",
  },
  pageNumber: {
    position: "absolute",
    fontSize: 8,
    bottom: 5,
    right: 10,
    textAlign: "right",
    color: "#a4a4a4",
  },
  createdBy: {
    position: "absolute",
    fontSize: 8,
    bottom: 5,
    left: 10,
    textAlign: "left",
    color: "#a4a4a4",
  },
  superscript: {
    fontSize: 10,
    marginBottom: 5,
    textTransform: "lowercase",
    textAlignVertical: "top", // Move up like superscript
  },
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gridTemplateRows: "repeat(4, 1fr)",
    gridColumnGap: 1,
    gridRowGap: 1,
  },
  checkBox: {
    width: "20px",
    height: "20px",
    borderRadius: "5px",
    border: "1px solid #000",
    // backgroundColor: "#666",
  },
  roundedBorder: {
    borderLeft: "1px solid #ccc", // outer border
    borderTop: "1px solid #ccc",
  },
  cell: {
    borderRight: "1px solid #ccc",
    borderBottom: "1px solid #ccc",
    padding: "4px",
    textAlign: "center",
    // display: "flex",
    // justifyContent: "center",
    // alignItems: "center",
  },
  cell0: {
    gridColumn: "span 2 / span 2",
    gridColumnStart: 1,
    gridRowStart: 1,
  },
  cell1: {
    gridColumn: "span 10 / span 10",
    gridColumnStart: 3,
    gridRowStart: 1,
  },
  cell2: { gridArea: "2 / 3 / 3 / 6" },
  cell3: { gridArea: "2 / 6 / 3 / 9" },
  cell4: { gridArea: "2 / 9 / 3 / 10" },
  cell5: { gridArea: "2 / 10 / 3 / 12" },
  cell6: { gridArea: "2 / 12 / 3 / 13" },
  cell7: { gridArea: "3 / 1 / 4 / 3" },
  cell8: { gridArea: "3 / 3 / 4 / 6" },
  cell9: { gridArea: "3 / 6 / 4 / 9" },
  cell10: { gridArea: "3 / 9 / 4 / 10" },
  cell11: { gridArea: "3 / 10 / 4 / 12" },
  cell12: { gridArea: "3 / 12 / 4 / 13" },
  cell13: { gridArea: "4 / 1 / 5 / 3" },
  cell14: { gridArea: "4 / 3 / 5 / 6" },
  cell15: { gridArea: "4 / 6 / 5 / 9" },
  cell16: { gridArea: "4 / 9 / 5 / 10" },
  cell17: { gridArea: "4 / 10 / 5 / 12" },
  cell18: { gridArea: "4 / 12 / 5 / 13" },

  cell11: { gridArea: "1 / 3 / 2 / 12" },
  cell22: { gridArea: "1 / 12 / 3 / 13" },
  cell33: { gridArea: "2 / 3 / 3 / 6" },
  cell44: { gridArea: "2 / 6 / 3 / 9" },
  cell55: { gridArea: "2 / 9 / 3 / 10" },
  cell66: { gridArea: "2 / 10 / 3 / 11" },
  cell77: { gridArea: "2 / 11 / 3 / 12" },
  cell88: { gridArea: "3 / 1 / 4 / 3" },
  cell99: { gridArea: "3 / 3 / 4 / 6" },
  cell100: { gridArea: "3 / 6 / 4 / 9" },
  cell111: { gridArea: "3 / 9 / 4 / 10" },
  cell122: { gridArea: "3 / 10 / 4 / 11" },
  cell133: { gridArea: "3 / 11 / 4 / 12" },
  cell144: { gridArea: "3 / 12 / 4 / 13" },
  cell155: { gridArea: "4 / 1 / 5 / 3" },
  cell166: { gridArea: "4 / 3 / 5 / 6" },
  cell177: { gridArea: "4 / 6 / 5 / 9" },
  cell188: { gridArea: "4 / 9 / 5 / 10" },
  cell199: { gridArea: "4 / 10 / 5 / 11" },
  cell200: { gridArea: "4 / 11 / 5 / 12" },
  cell211: { gridArea: "4 / 12 / 5 / 13" },
});
